/**
 * @author Evgenij Tyan
 * @version 1.0.1
 * @since 1.0.0
 */
import produce from 'immer';
import { Reducer } from 'redux';

import { TExtFilterApiAction } from '../actions/extFilterApiActions';
import {
    CLEAR_FILTER,
    CLEAR_FILTER_FAILED,
    CLEAR_FILTER_SUCCESSFUL,
    DELETE_EXTFILTER,
    DELETE_EXTFILTER_FAILED,
    DELETE_EXTFILTER_SUCCESSFUL,
    LOAD_EXTFILTER,
    LOAD_EXTFILTER_FAILED,
    LOAD_EXTFILTER_SUCCESSFUL,
    SAVE_EXTFILTER,
    SAVE_EXTFILTER_FAILED,
    SAVE_EXTFILTER_SUCCESSFUL,
    SEND_EXTFILTER,
    SEND_EXTFILTER_FAILED,
    SEND_EXTFILTER_SUCCESSFUL,
    SET_EXTFILTER_TAB_INDEX,
    UPDATE_EXTFILTER,
    UPDATE_EXTFILTER_FAILED,
    UPDATE_EXTFILTER_SUCCESSFUL,
} from '../constants/extFilterApiConstants';
import { IExtFilterData } from '../types/extFilterTypes';

/**
 * @description Api reducer state
 * @extends IExtFilterData
 * @property {boolean} dataLoaded - data load flag
 * @property {string} message - error message
 */
export interface IExtFilterApiInitialState extends IExtFilterData {
    dataLoaded: boolean;
    message?: string;
    tabIndex?: number;
    isClearFilterLoading: boolean;
}

export const initialState: IExtFilterApiInitialState = {
    dataLoaded: false,
    extFilter: {
        condition: '',
        id: '',
        idsFilter: '',
        items: [],
        name: '',
    },
    extFilterList: [],
    extFilterMeta: [],
    message: '',
    isClearFilterLoading: false,
};
/**
 * Reducer for control external filter
 */
const extFilterApiReducer: Reducer<IExtFilterApiInitialState, TExtFilterApiAction> =
    (state: IExtFilterApiInitialState = initialState, action: TExtFilterApiAction) =>
    produce(state, (draft) => {
        switch (action.type) {
            // SET TAB INDEX
            case SET_EXTFILTER_TAB_INDEX:
                draft.tabIndex = action.payload;
                break;

            // LOAD CURRENT SETTINGS
            case LOAD_EXTFILTER:
                draft.dataLoaded = false;
                break;
            case LOAD_EXTFILTER_SUCCESSFUL:
                draft.extFilter = action.payload.extFilter;
                draft.extFilterList = action.payload.extFilterList;
                draft.extFilterMeta = action.payload.extFilterMeta;
                draft.dataLoaded = true;
                break;
            case LOAD_EXTFILTER_FAILED:
                draft.message = action.payload;
                break;

            // SEND NEW SETTINGS
            case SEND_EXTFILTER:
                break;
            case SEND_EXTFILTER_SUCCESSFUL:
                draft.extFilter = { ...draft.extFilter, ...action.payload };
                break;
            case SEND_EXTFILTER_FAILED:
                draft.message = action.payload;
                break;

            // SAVE NEW SETTINGS
            case SAVE_EXTFILTER:
                break;
            case SAVE_EXTFILTER_SUCCESSFUL:
                draft.extFilterList.push(action.payload);
                break;
            case SAVE_EXTFILTER_FAILED:
                draft.message = action.payload;
                break;

            // UPDATE SETTINGS
            case UPDATE_EXTFILTER:
                break;
            case UPDATE_EXTFILTER_SUCCESSFUL:
                draft.extFilterList = action.payload;
                break;
            case UPDATE_EXTFILTER_FAILED:
                draft.message = action.payload;
                break;

            // DELETE SETTINGS
            case DELETE_EXTFILTER:
                break;
            case DELETE_EXTFILTER_SUCCESSFUL:
                draft.extFilterList = action.payload;
                break;
            case DELETE_EXTFILTER_FAILED:
                draft.message = action.payload;
                break;

            // CLEAR SETTINGS
            case CLEAR_FILTER:
                draft.isClearFilterLoading = true;
                break;
            case CLEAR_FILTER_SUCCESSFUL:
                draft.extFilter = initialState.extFilter;
                draft.extFilterList = initialState.extFilterList;
                draft.extFilterMeta = initialState.extFilterMeta;
                draft.dataLoaded = false;
                draft.isClearFilterLoading = false;
                break;
            case CLEAR_FILTER_FAILED:
                draft.message = action.payload;
                draft.isClearFilterLoading = false;
                break;

            default:
                break;
        }
    });
export default extFilterApiReducer;
